'use strict';

var MULTIPLIERS = {
  'Hours': 60 * 60 * 1000,
  'Minutes': 60 * 1000,
  'Seconds': 1000,
  'Milliseconds': 1
};

module.exports = MULTIPLIERS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/range/var/MULTIPLIERS.js
// module id = 297
// module chunks = 0